/**
 * Hub messagerie : 3 onglets — Camarades / Personnel / Scolarité.
 * v2 2026-08-31 : ajout onglet Personnel (chat instantané agents/formateurs).
 * Onglet contrôlé par `?tab=camarades|personnel|scolarite`.
 */
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, MessageSquare, Users, Briefcase } from 'lucide-react';
import { PortailLayout } from '../PortailLayout';
import MesMessagesScolarite from './MesMessagesScolarite';
import MessagesCamarades from './MessagesCamarades';
import MessagesPersonnel from './MessagesPersonnel';

type Tab = 'camarades' | 'personnel' | 'scolarite';

export default function Messagerie() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const raw = (params.get('tab') || 'camarades').toLowerCase();
  const tab: Tab =
    raw === 'scolarite' ? 'scolarite'
      : raw === 'personnel' ? 'personnel'
        : 'camarades';

  const setTab = (t: Tab) => {
    params.set('tab', t);
    // Nettoyer un ?conv= précédent quand on change d'onglet
    if (t !== tab) params.delete('conv');
    setParams(params, { replace: true });
  };

  return (
    <PortailLayout showHeader title="Messagerie" fullWidth>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate('/portail/accueil')}
            className="p-2 hover:bg-gray-800 rounded text-gray-300"
            aria-label="Retour à l'accueil"
          >
            <ArrowLeft size={18} />
          </button>
          <h2 className="font-semibold text-gray-100 text-sm">Messagerie</h2>
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-lg p-1 grid grid-cols-3 gap-1">
          <button
            onClick={() => setTab('camarades')}
            className={`py-2 rounded text-xs sm:text-sm font-medium inline-flex items-center justify-center gap-1.5 transition-colors ${
              tab === 'camarades' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <Users size={14} /> Camarades
          </button>
          <button
            onClick={() => setTab('personnel')}
            className={`py-2 rounded text-xs sm:text-sm font-medium inline-flex items-center justify-center gap-1.5 transition-colors ${
              tab === 'personnel' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <Briefcase size={14} /> Personnel
          </button>
          <button
            onClick={() => setTab('scolarite')}
            className={`py-2 rounded text-xs sm:text-sm font-medium inline-flex items-center justify-center gap-1.5 transition-colors ${
              tab === 'scolarite' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-800'
            }`}
          >
            <MessageSquare size={14} /> Scolarité
          </button>
        </div>

        <div className="pt-1">
          {tab === 'camarades' && <MessagesCamarades embedded />}
          {tab === 'personnel' && <MessagesPersonnel embedded />}
          {tab === 'scolarite' && <MesMessagesScolarite embedded />}
        </div>
      </div>
    </PortailLayout>
  );
}
